import { ITaskDenormalized } from '@dadohr/shared/domainTypes/experience';
import styled from '@emotion/styled';
import { sortBy } from 'lodash';
import { useMemo } from 'react';
import { InfoBox } from '../../../../../../components/InfoBox';
import { useUnsafeTranslation } from '../../../../../../i18next';
import { FlexContainerVertical } from '../../../../../../layout/Flex';
import { EmployeeAppCard } from '../EmployeeAppCard';
import { TaskLink, TaskWithDueDate } from '../Tasks';

const InfoContainer = styled('div')((p) => ({
  width: '100%',
  padding: p.theme.spacing(2),
  paddingBottom: 0
}));

const Container = styled(FlexContainerVertical)((p) => ({
  border: `1px ${p.theme.custom.colors.gray.w200} solid`,
  borderRadius: p.theme.custom.border.radius(2),
  backgroundColor: 'white',
  overflow: 'hidden'
}));

const Body = ({
  overdueTasks,
  actorAccessToken,
  instanceAccessToken,
  returnTo
}: {
  overdueTasks: ITaskDenormalized[];
  actorAccessToken: string;
  instanceAccessToken: string;
  returnTo?: string;
}) => {
  const { t } = useUnsafeTranslation();
  const sorted = useMemo(() => {
    return sortBy(overdueTasks, (tsk) => tsk.end?.toMillis() || 0);
  }, [overdueTasks]);
  return (
    <Container fullWidth spacing={0}>
      <InfoContainer>
        <InfoBox color="red" textColor="red" fullWidth>
          {t(
            'You have overdue tasks from previous weeks. Please complete them as soon as possible.'
          )}
        </InfoBox>
      </InfoContainer>

      {sorted.map((tsk, i) => (
        <EmployeeAppCard
          key={tsk.id}
          hoverEffect
          noRoundBorders
          noTopBorder={i === 0}
          noBottomBorder={i === sorted.length - 1}
        >
          <TaskLink
            actorAccessToken={actorAccessToken}
            instanceAccessToken={instanceAccessToken}
            taskId={tsk.id}
            returnTo={returnTo}
          >
            <TaskWithDueDate d={tsk} />
          </TaskLink>
        </EmployeeAppCard>
      ))}
    </Container>
  );
};

export const OverdueSection = (props: {
  overdueTasks: ITaskDenormalized[];
  actorAccessToken: string;
  instanceAccessToken: string;
  returnTo?: string;
}) => {
  if (!props.overdueTasks.length) {
    return null;
  }

  return <Body {...props} />;
};
